/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Grid,
  FormControl,
  Typography,
  Link,
  Card,
  CardContent,
  Tooltip,
  Dialog,
  DialogContent,
  LinearProgress,
  Popper,
  Box,
  Paper,
  DialogTitle,
  Autocomplete,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { useSelector, useDispatch } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import deLocale from 'date-fns/locale/pt-BR';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import AutocompleteParameters from '../../components/AutocompleteParameters';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import HandleWaterAnalysis from 'pages/analyse/handleWaterAnalysis';
import FormDialogContent from './formDialog/formDialogContent';
import { POND_STATUS_CYCLE, parameterTypes } from 'utils/consts';
import { labelField } from 'utils';

function Measurement() {
  const location = useLocation();
  const [selectedDate, handleDateChange] = useState(new Date());
  const [selectedHour, handleHourChange] = useState(new Date());
  const [pondCycles, setPondCycles] = useState([]);
  const [selectedPondCycle, handlePondCycle] = useState(null);
  const [parameters, setParameters] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [forms, setForms] = useState([]);
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [samples, setSamples] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedForm, handleForm] = useState('');
  const [selectedOption, handleOption] = useState(null);
  const [show, setShow] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();
  const disable = useSelector((state) => state.disable.disable);
  const notIsFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess,
  );
  const error = Error();
  const success = Success();
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle,
  );
  const parametersIsNull = useState(false);
  const [openPondModal, setOpenPondModal] = useState(false);
  const [openLinearProgress, setOpenLinearProgress] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    handlePondCycle(data.cycle);
    handleForm(parseInt(data.form));

    setSelectedParameters(data.parameters.map((value) => value.parameter));

    const parametersFormateds = data.parameters;
    setSamples(parametersFormateds);
    formik.setFieldValue('parameters', parametersFormateds);

    // Se vier o id da coluna a ser copiada pelo location, id sera null. Senão id veio params,
    // e estamos tratando da edição dos dados, e id não pode ser null
    // Não podemos setar data e hora, pois pegaremos a data e hora atuais
    handleDateChange(new Date(data.get_at));
    handleHourChange(new Date(data.get_at));
  }

  function updateSamples(options) {
    formik.setFieldValue('parameters', options);
  }

  const getParameters = () => {
    api.get('/parameters').then((parameters_) => {
      setParameters(
        parameters_.data
          .filter((parameter) => parameter.type === 'Água')
          .map((parameter) => ({
            ...parameter,
            parameter_id: parameter.id,
          })),
      );
    });
  };

  useEffect(() => {
    api.get(`/cycles/cycle-code/${selectedCycle.id}`).then((pondCycles_) => {
      setPondCycles(
        pondCycles_.data.filter(
          (pond) => pond.status === POND_STATUS_CYCLE.CULTIVANDO || pond.status === POND_STATUS_CYCLE.PREPARANDO,
        ),
      );
    });

    getParameters();

    api
      .get('/forms')
      .then((forms_) => setForms(forms_.data.filter((form) => form.type === 'Água')));
  }, [selectedCycle]);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));

    if (!id) {
      data.parameters.map((item) => {
        item.parameter_id = item.id;
        delete item.id;
      });
    }

    try {
      id
        ? await api.put(`/measurements/${id}`, { ...data })
        : await api.post('/measurements', { ...data });
      success();
      history.push('/measurements');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      cycle: '',
      get_at: '',
      parameters: {},
      // workers: ""
    },
    validationSchema: Yup.object({
      cycle: Yup.number().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      if (values.parameters.length === 0) {
        parametersIsNull[1](true);
        return false;
      }
      dispatch(setLoading(true));
      selectedDate.setHours(selectedHour.getHours());
      selectedDate.setMinutes(selectedHour.getMinutes());
      values.get_at = selectedDate.toUTCString();
      values.cycle = selectedPondCycle.id;
      values.form = id;
      request(values);
    },
  });

  useEffect(() => {
    formik.values.cycle = selectedPondCycle?.id;
  }, [selectedPondCycle]);

  // Auxilia na escolha do parâmetro
  async function handleChooseParameter(event) {
    formik.values.parameter = event;

    formik.values.value = '';
    formik.values.optionValue = '';
    handleOption(null);

    if (event.id !== undefined) {
      const loadData = await api.get(`/parameters/${event.id}`);
      if (loadData.data.hasOptions === false) {
        setShow(false);
      } else {
        setShow(true);
        setOptions(loadData.data.options);
      }
    }
  }

  useEffect(() => {
    if (selectedParameters && !id) {
      setSamples(selectedParameters);
      formik.setFieldValue('parameters', selectedParameters);
    }
  }, [selectedParameters]);

  useEffect(() => {
    // Carrega os dados na tabela de cadastro
    if (selectedForm) {
      if (selectedForm.parameters !== undefined) {
        const parametersFormateds = selectedForm.parameters.map((parameter) => ({
          ...parameter.parameter,
          id: parameter.parameter_id,
          parameter_id: parameter.parameter_id,
        }));

        setSelectedParameters(parametersFormateds);

        setSamples(parametersFormateds);
        formik.setFieldValue('parameters', parametersFormateds);

        getParameters();
      }
    }
  }, [selectedForm, id]);

  function handleParameters(values) {
    setSelectedParameters(values);
  }

  /**
 * @param {React.ChangeEvent<{}>} event
 * @param {AutocompleteChangeReason} reason
 */
  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick') {
      setOpenPondModal(false);
    }
    if (reason === 'escapeKeyDown') {
      setOpenPondModal(false);
    }
  };

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados de Análise de Água
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Nessa tela é possível cadastrar informações referentes a análise da água de um viveiro. É possível utilizar mais de um parâmetro.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Dialog
                  style={{ padding: '15rem' }}
                  open={openPondModal}
                  fullWidth
                  maxWidth="lg"
                  onClose={handleCloseModal}
                >
                  {openLinearProgress && <LinearProgress />}
                  <DialogTitle style={{ paddingBottom: '0' }}>
                    <span style={{ paddingLeft: '1rem' }}>
                      Dados do Formuláriooooo
                    </span>
                  </DialogTitle>
                  <DialogContent>
                    <FormDialogContent
                      setForms={(data) => {
                        const filteredByMeasurement = data.filter((item) => item.type.includes(parameterTypes.AGUA));
                        setForms(filteredByMeasurement);
                      }}
                      typeName={parameterTypes.AGUA}
                      setOpenPondModal={setOpenPondModal}
                      setOpenAutocomplete={setOpenAutocomplete}
                      setOpenLinearProgress={setOpenLinearProgress}
                    />
                  </DialogContent>
                </Dialog>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <Autocomplete
                      noOptionsText={(
                        <Typography>
                          Nenhum viveiro configurado para esse ciclo.
                          <Link
                            style={{ marginLeft: '1%', cursor: 'pointer' }}
                            color="primary"
                            onMouseDown={() => {
                              history.push(
                                notIsFirstAccess ? '/first-cycle' : '/cycle',
                              );
                            }}
                          >
                            Configurar agora +
                          </Link>
                        </Typography>
                      )}
                      name="cycle"
                      options={pondCycles}
                      value={selectedPondCycle}
                      getOptionLabel={(options) => options.pond.description}
                      onChange={(p, v) => {
                        handlePondCycle(v);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={labelField('Viveiro')}
                          variant="outlined"
                          onBlur={formik.handleBlur}
                          error={formik.touched.cycle && formik.errors.cycle}
                          helperText={
                            formik.touched.cycle && formik.errors.cycle
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Grid>

                {!id && (
                  <Grid item xs={12} sm={6}>
                    <FormGroup>
                      <Autocomplete
                        open={openAutocomplete}
                        onOpen={() => {
                          setOpenAutocomplete((state) => !state);
                        }}
                        onClose={() => {
                          setOpenAutocomplete((state) => !state);
                        }}
                        noOptionsText={false}
                        id="form"
                        name="form"
                        options={forms}
                        value={selectedForm}
                        getOptionLabel={(options) => (typeof options === 'string' ? options : options.name)}
                        onChange={(p, v) => {
                          handleForm(v);
                        }}
                        onBlur={formik.handleBlur}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Formulário"
                            variant="outlined"
                          // disabled={id?true:false}
                          />
                        )}
                        PopperComponent={(param) => (
                          <Popper {...param}>
                            <Box {...param} />
                            <Paper style={{ height: '100%' }}>
                              <Typography
                                style={{ padding: '1rem', color: 'gray' }}
                              >
                                {forms.length === 0
                                  ? 'Não existe formulário cadastrado nessa medição.'
                                  : 'Deseja cadastrar outro formulário?'}
                                {' '}
                                <Link
                                  style={{ cursor: 'pointer' }}
                                  color="primary"
                                  onMouseDown={() => {
                                    setOpenPondModal((state) => !state);
                                  }}
                                >
                                  Cadastrar Formulário +
                                </Link>
                              </Typography>
                            </Paper>
                          </Popper>
                        )}
                      />
                    </FormGroup>
                  </Grid>
                )}
                {!id && (
                  <AutocompleteParameters
                    type={parameterTypes.AGUA}
                    form_id={null}
                    parameters={selectedParameters}
                    options={parameters}
                    parametersIsNull={parametersIsNull}
                    callback={handleParameters}
                  />
                )}
                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <LocalizationProvider
                      adapterLocale={deLocale}
                      dateAdapter={DateFnsUtils}
                    >
                      <DatePicker
                        InputLabelProps={{
                          style: { pointerEvents: 'auto' },
                        }}
                        fullWidth
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage="Data Inválida"
                        label={<div>Coletado em (data)</div>}
                        format="dd/MM/yyyy"
                        value={selectedDate}
                        onChange={(date) => handleDateChange(date)}
                        // inputFormat="DD/MM/YYYY"
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <LocalizationProvider
                      adapterLocale={deLocale}
                      dateAdapter={DateFnsUtils}
                    >
                      <TimePicker
                        ampm={false}
                        InputLabelProps={{
                          style: { pointerEvents: 'auto' },
                        }}
                        fullWidth
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage="Hora inválida"
                        label={<div>Coletado em (hora)</div>}
                        format="HH:mm"
                        value={selectedHour}
                        onChange={(date) => handleHourChange(date)}
                        // inputFormat="HH:mm"
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormGroup>
                </Grid>
              </Grid>
              <h3 className="titleb">Parâmetros</h3>
              <FormGroup>
                <FormControl>
                  <HandleWaterAnalysis
                    label="Valor"
                    parameters={samples}
                    samples={samples}
                    callback={updateSamples}
                    id={id}
                  >
                    {' '}
                  </HandleWaterAnalysis>
                </FormControl>
              </FormGroup>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/measurements/"
            routeDelete="/measurements"
            returnRoute="/measurements"
            id={id}
            disable={disable}
            message="A exclusão dessa medida pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Measurement;
